


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import HtmlTypeConst from '../../../../domain/Constants/HtmlTypeConst';
import { Container } from 'inversify';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import { useStore } from 'vuex';	

export default defineComponent({
    name: 'dynamic_html_small',
    props:
    {

        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
    },
    setup(props, context) {
        //
        
        const store = useStore();
        const { vmodel, getPropertyValue, getPropertyBooleanValue, loaded, componentData, resolveExpressions, baseOnUnmount
            ,fieldKey,fieldKeyComponentDataSourceId } = ComponentCommon(props, context,store);

        onMounted(() => {
            // resolveExpressions();
        })

        onUnmounted(() => {
            baseOnUnmount();
        })


        return {
            MessageService,
            MessageType,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            HtmlTypeConst,
            loaded,
            BaseControlTypeConst,
            fieldKey,
            fieldKeyComponentDataSourceId
        };
    },
});
